export enum RouteKeys {
  Home = "/",
  Login = "/auth/login",
  ResetPassword = "/auth/reset-password",
  ForgotPassword = "/auth/forgot-password",
  AzureLogin = "/auth/aad-redirect",
  Leads = "/leads",
  Calendar = "/calendar",
  LeadSettings = "/lead-settings",
  CompanySettings = "/company-settings",
  RequirementSettings = "/requirement-settings",
  InvoiceSettings = "/invoice-settings",
  ProposalSettings = "/proposal-settings",
  DocumentSettings = "/document-settings",
  GeneralSettings = "/general-settings",
  ContentSettings = "/content-settings",
  NotFound = "/page-not-found",
  StaffMembers = "/staff-members",
  Roles = "/roles",
  Enquiry = "/enquiry",
  Requirements = "/requirements",
  ConfigurationReport = "/configuration/report",
  Lead360View = "/lead-360",
  LeadConversionReport = "/report/lead-conversion-report",
  ActivitySummaryReport = "/report/activity-summary-report",
  SiteVisitReport = "/report/site-visit-report",
  CollectionSegregationReport = "/report/collection-segregation-report",
  LeadLostReport = "/report/lead-lost-report",
  DailySalesReport = "/report/daily-sales-report",
  ShowroomManagement = "/showroom-management",
  Customers = "/customers",
  Vehicles = "/vehicles",
  Projects = "/projects",
  VehicleDetails = "/vehicles/:vehicleId",
  ProjectDetails = "/projects/:projectId",
  PropertyDetails = "/properties/:propertyId",
  Search = "/search",
  Profile = "/profile",
  LeadEnquiry = "/report/lead-enquiry",
  LeadLostRequests = "/lead-lost-requests",
  VehicleModels = "/vehicle-models",
  LeadJourney = "/report/lead-journey",
  RolesAcceessibility = "/roles-acceessibility",
  EmailReport = "/email-report",
  PaymentReport = "/report/payment",
  MapVariant = "/map-variant",
  Queue = "/queue",
  LeadSummaryReport = "/lead-summary-report",
  Company = "/company",
  Company360View = "/company-360",
  Properties = "/properties",
  requirementDetailPopup = "/requirement-detail-popup",
  requirementPropertyDetailPopup = "/requirement-property-detail-popup",
  RequirementComparePage = "/requirement-compare",
  RequirementListingPage = "/requirement-listing",
  SiteVisitPage = "/site-visit",
  Proposal = "/proposal/:id",
  ScheduleSiteVisit = "/schedule-site-visit",
  ProposalPopup = "/proposal-popup",
  Requirement = "/requirement/:id",
  Agreement = "/agreement/:id",
  LegalDueDiligenceSettings = "/legal-due-diligence-settings",
  TenancyExpiryTracker = "/tenancy-expiry-tracker",
  Invoice = "/invoice/:id",
  GlobalSearch = "/global-search",
  InvoiceList = "/invoice",
  ProposalList = "/proposal",
  TermSheetList = "/termsheet",
  LetterOfIntentList = "/letter-of-intent",
  agreementList = "/agreement",
  feeLetterList = "/fee-letter",
  // Company360 = "/company-360-new",
  Transaction360 = "/transaction360",
  MediaSettings = "/media-settings"
}
